import { IFileReference } from "wombat-global/src/typings";
import { isObject } from "wombat-global/src/utilities";

export type LocalFileRef = IFileReference;

export function isRemoteFileRef(obj: unknown): obj is IFileReference {
  return isObject(obj) && Object.getOwnPropertyNames(obj).includes("ref");
}

export function isLocalFileRef(obj: unknown): obj is LocalFileRef {
  return (
    isObject(obj) && Object.getOwnPropertyNames(obj).includes("fileSystemRef")
  );
}

/**
 * On refresh of page the stored file selections are invalid (I don't know of a way to maintain the file selections) so we need to filter out the invalid ones
 */
export function isValidFileRef(
  file: unknown,
): file is LocalFileRef | IFileReference {
  return isRemoteFileRef(file) || isLocalFileRef(file);
}

export type FileRecord = Record<string, LocalFileRef[] | undefined>;
